var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"page page-redirect"},[_c('div',{staticClass:"redirect-content"},[_c('h2',[_vm._v("Opening ChalkySticks...")]),_c('p',[_vm._v(" If the app doesn't open automatically, "),_c('a',{attrs:{"href":_vm.fallbackUrl},on:{"click":_vm.Handle_OnClickOpenWeb}},[_vm._v("click here")]),_vm._v(" . ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }